import { SvgIcon, SxProps } from "@mui/material";
import LocationDotSvg from "jsx:../../../Images/Icons/FontAwesome/solid/location-dot.svg";

export function LocationDotSolidIcon(props: SxProps) {
    return <SvgIcon component={LocationDotSvg} inheritViewBox sx={props} />;
}
